import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import apiClient from "../api/apiClient";
import { McCard } from "@maersk-global/mds-react-wrapper/components-core/mc-card";
import '../styles/HomeGraphMetrics.css';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
  } from '@mui/material';
import RegionAreaCountryTable from './RegionAreaCountryTable';
import Select from "react-select";
import { McDateRange } from "@maersk-global/mds-react-wrapper/components-core/mc-date-range";
import HoverTip from "@mui/material/Tooltip";
import { Button } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { apiUrl } from "../authconfig";
const HomeGraphMetrics = () => {
    const [projStatusVsCountryRoleData, setProjStatusVsCountryRoleData] = useState([]);
    const [oppOwnCountryVsCountryRoleData, setOppOwnCountryVsCountryRoleData] = useState([]);
    const [oppOwnCountryVsStatusData, setOppOwnCountryVsStatusData] = useState([]);
    const [regionAreaCountryData, setRegionAreaCountryData] = useState([]);
    const [userNotAssigned, setUserNotAssigned] = useState(false);
    const [isAllStatus, setIsAllStatus] = useState(false);

    useEffect(() => {
    apiClient.get(`${apiUrl}/api/kpiOpportunityMetrics/region-area-summary`)
        .then(res => setRegionAreaCountryData(res.data))
        .catch(err => console.error("Failed to load region-area-country summary", err));
    }, []);

    useEffect(() => {
        // Fetch Project Status VS Country Role
        apiClient.get(`${apiUrl}/api/opportunities/statistics/projStatusVScountryRole`)
            .then(response => setProjStatusVsCountryRoleData(response.data))
            .catch(error => console.error("Error fetching projStatusVScountryRoleData", error));

        // Fetch Opportunity Owner Country VS Country Role
        apiClient.get(`${apiUrl}/api/opportunities/statistics/oppOwnCountryVScountryRole`)
            .then(response => setOppOwnCountryVsCountryRoleData(response.data))
            .catch(error => console.error("Error fetching oppOwnCountryVsCountryRoleData", error));

        // Fetch Opportunity Owner Country VS Status
        apiClient.get(`${apiUrl}/api/opportunities/statistics/oppOwnCountryVSstatus`)
            .then(response => setOppOwnCountryVsStatusData(response.data))
            .catch(error => console.error("Error fetching oppOwnCountryVsStatusData", error));
    }, []);
    const customStyles = {
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isFocused ? "#f0f8ff" : "white", 
          color: state.isFocused ? "#0078d7" : "black", 
          cursor: "pointer",
        }),
        control: (provided) => ({
          ...provided,
          borderColor: "#cfcfcf",
          "&:hover": {
            borderColor: "#0078d7", 
          },
        }),
    };

    const getStartOfWeek = () => {
        let date = new Date();
        let dayOfWeek = date.getDay();
        // Monday to Sunday week
        let difference = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
        date.setDate(date.getDate() - difference);
        return date.toISOString().slice(0, 10);
    };

    const getToday = () => {
        let date = new Date();
        return date.toISOString().slice(0, 10);
    }

    const [filterOptions, setFilterOptions] = useState({
        projectIds: [],
        assignedUsers: [],
        opportunityReferences: [],
        accountNames: [],
        productBundles: [],
        cxChannels: [],
        assignedToFunctions: [],
        countries: [],
        countryRoles: [],
        projectPhases: [],
        projectStatuses: [],
        fromDate: getStartOfWeek(),
        toDate: getToday(),
    });

    const [selectedFilters, setSelectedFilters] = useState({
        projectIds: null,
        opportunityReferences: null,
        accountNames: null,
        assignedUsers: null,
        productBundles: null,
        cxChannels: null,
        assignedToFunctions: null,
        countries: null,
        countryRoles: null,
        projectPhases: null,
        projectStatuses: null,
        fromDate: null,
        toDate: null,
    });
    const handleFilterChange = (field, value) => {
        console.log(
          "handleFilterChange called with field:",
          field,
          "and value:",
          value
        );
        setSelectedFilters((prevFilters) => {
          if (field === "dateFilter") {
            return {
              ...prevFilters,
              fromDate: value ? value.fromDate : null,
              toDate: value ? value.toDate : null,
              fromToChanged: true,
            };
          } else {
            return {
              ...prevFilters,
              [field]: value ? value.value : null,
            };
          }
        });
        if (
          field === "assignedUsers" &&
          !filterOptions.assignedUsers.includes(value?.value)
        ) {
          setUserNotAssigned(true);
        } else {
          setUserNotAssigned(false);
        }
    };

    const handleInputChange = (inputValue, actionMeta) => {
        if (
          actionMeta.action === "input-change" &&
          !filterOptions.assignedUsers.some((user) => user?.includes(inputValue))
        ) {
          setUserNotAssigned(true);
        } else {
          setUserNotAssigned(false);
        }
    };

    const noOptionsMessage = () => {
        return (
          <span style={{ color: "red" }}>User has not been assigned any case</span>
        );
    };

    const setDateFilter = (event) => {
        if (
          selectedFilters.fromDate !== event.target.value.from ||
          selectedFilters.toDate !== event.target.value.to
        )
          console.log("event", event.target.value);
        {
          setSelectedFilters((prevState) => ({
            ...prevState,
            fromDate: event.target.value.from,
            toDate: event.target.value.to,
            fromToChanged: true,
          }));
        }
    };

    

    const renderTable = (data, rowKey) => {
        if (data.length === 0) return null;
        
        const columns = Object.keys(data[0]).filter(k => k !== rowKey);
        
        return (
            <TableContainer component={Paper}>
            <Table size="small" aria-label="data table">
                <TableHead>
                <TableRow>
                    <TableCell><strong>{rowKey}</strong></TableCell>
                    {columns.map((col) => (
                    <TableCell key={col} align="right"><strong>{col}</strong></TableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody>
                {data.map((row, i) => (
                    <TableRow key={i}>
                    <TableCell>{row[rowKey]}</TableCell>
                    {columns.map((col) => (
                        <TableCell key={col} align="right">{row[col]}</TableCell>
                    ))}
                    </TableRow>
                ))}
                </TableBody>
            </Table>
            </TableContainer>
        );
    };

    return (
        // <div>
        //     <div style={{display:'flex',alignItems: 'center', paddingTop: '15px'}}>
        //         {/* <McTabBar>
        //             <McTab slot="tab" label="Open Projects PortFolio Tables" icon="table" ></McTab>
        //         </McTabBar> */}
        //         <div
        //         style={{
        //         display: "flex",
        //         gap: "10px",
        //         flexWrap: "wrap",
        //         marginBottom: "20px",
        //         border: "1px solid #cfcfcf",
        //         padding: "10px",
        //         backgroundColor: "#fff",
        //         }}
        //     >
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions.projectIds.map((id) => ({
        //             value: id,
        //             label: id,
        //             }))}
        //             placeholder="Project ID"
        //             value={
        //             selectedFilters?.projectIds && {
        //                 value: selectedFilters?.projectIds,
        //                 label: selectedFilters?.projectIds,
        //             }
        //             }
        //             isClearable
        //             onChange={(value) => handleFilterChange("projectIds", value)}
        //         />
        //         </div>
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions.opportunityReferences?.map((ref) => ({
        //             value: ref,
        //             label: ref,
        //             }))}
        //             placeholder="Opportunity Reference"
        //             isClearable
        //             value={
        //             selectedFilters?.opportunityReferences && {
        //                 value: selectedFilters?.opportunityReferences,
        //                 label: selectedFilters?.opportunityReferences,
        //             }
        //             }
        //             onChange={(value) =>
        //             handleFilterChange("opportunityReferences", value)
        //             }
        //         />
        //         </div>
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions.accountNames?.map((name) => ({
        //             value: name,
        //             label: name,
        //             }))}
        //             placeholder="Account Name"
        //             isClearable
        //             value={
        //             selectedFilters?.accountNames && {
        //                 value: selectedFilters?.accountNames,
        //                 label: selectedFilters?.accountNames,
        //             }
        //             }
        //             onChange={(value) => handleFilterChange("accountNames", value)}
        //         />
        //         </div>
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions.assignedUsers?.map((user) => ({
        //             value: user,
        //             label: user,
        //             }))}
        //             placeholder="Assigned User"
        //             isClearable
        //             value={
        //             selectedFilters?.assignedUsers && {
        //                 value: selectedFilters?.assignedUsers,
        //                 label: selectedFilters?.assignedUsers,
        //             }
        //             }
        //             onChange={(value) => handleFilterChange("assignedUsers", value)}
        //             onInputChange={handleInputChange}
        //             noOptionsMessage={noOptionsMessage}
        //         />
        //         </div>
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions?.productBundles?.map((family) => ({
        //             value: family,
        //             label: family,
        //             }))}
        //             placeholder="Product Family"
        //             value={
        //             selectedFilters?.productBundles && {
        //                 value: selectedFilters?.productBundles,
        //                 label: selectedFilters?.productBundles,
        //             }
        //             }
        //             isClearable
        //             onChange={(value) =>
        //             handleFilterChange("productBundles", value)
        //             }
        //         />
        //         </div>
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions?.cxChannels?.map((channel) => ({
        //             value: channel,
        //             label: channel,
        //             }))}
        //             placeholder="CX Channel"
        //             value={
        //             selectedFilters?.cxChannels && {
        //                 value: selectedFilters?.cxChannels,
        //                 label: selectedFilters?.cxChannels,
        //             }
        //             }
        //             isClearable
        //             onChange={(value) => handleFilterChange("cxChannels", value)}
        //         />
        //         </div>
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions?.assignedToFunctions?.map((func) => ({
        //             value: func,
        //             label: func,
        //             }))}
        //             placeholder="Assigned To Function"
        //             value={
        //             selectedFilters?.assignedToFunctions && {
        //                 value: selectedFilters?.assignedToFunctions,
        //                 label: selectedFilters?.assignedToFunctions,
        //             }
        //             }
        //             isClearable
        //             onChange={(value) =>
        //             handleFilterChange("assignedToFunctions", value)
        //             }
        //         />
        //         </div>
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions?.countries?.map((country) => ({
        //             value: country,
        //             label: country,
        //             }))}
        //             placeholder="Country"
        //             value={
        //             selectedFilters?.countries && {
        //                 value: selectedFilters?.countries,
        //                 label: selectedFilters?.countries,
        //             }
        //             }
        //             isClearable
        //             onChange={(value) => handleFilterChange("countries", value)}
        //         />
        //         </div>
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions.countryRoles?.map((role) => ({
        //             value: role,
        //             label: role,
        //             }))}
        //             placeholder="Country Role"
        //             value={
        //             selectedFilters?.countryRoles && {
        //                 value: selectedFilters?.countryRoles,
        //                 label: selectedFilters?.countryRoles,
        //             }
        //             }
        //             isClearable
        //             onChange={(value) => handleFilterChange("countryRoles", value)}
        //         />
        //         </div>
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions.projectPhases?.map((phase) => ({
        //             value: phase,
        //             label: phase,
        //             }))}
        //             placeholder="Project Phase"
        //             value={
        //             selectedFilters?.projectPhases && {
        //                 value: selectedFilters?.projectPhases,
        //                 label: selectedFilters?.projectPhases,
        //             }
        //             }
        //             isClearable
        //             onChange={(value) => handleFilterChange("projectPhases", value)}
        //         />
        //         </div>
        //         <div style={{ width: "200px" }}>
        //         <Select
        //         styles={customStyles}
        //             options={filterOptions.projectStatuses?.map((status) => ({
        //             value: status,
        //             label: status,
        //             }))}
        //             placeholder="Project Status"
        //             value={
        //             selectedFilters?.projectStatuses && {
        //                 value: selectedFilters?.projectStatuses,
        //                 label: selectedFilters?.projectStatuses,
        //             }
        //             }
        //             isClearable
        //             onChange={(value) =>
        //             handleFilterChange("projectStatuses", value)
        //             }
        //         />
        //         </div>

        //         <div
        //         style={{
        //             border: "1px solid #cfcfcf",
        //             borderRadius: "4px",
        //             padding: "0 0 0 10px",
        //             backgroundColor: "#fff",
        //             display: "flex",
        //             alignItems: "center",
        //         }}
        //         >
        //         <McDateRange
        //             className="custom-date-range"
        //             labelposition="left"
        //             name="dateFilter"
        //             format="YYYY-MM-DD"
        //             placeholder="YYYY-MM-DD"
        //             fit="small"
        //             style={{ marginRight: "12px" }}
        //             input={(value) => setDateFilter(value)}
        //         />
        //         </div>
        //         <div>
        //         <HoverTip title="Apply Filter">
        //             <Button
        //             variant="contained"
        //             color="primary"
        //             // onClick={applyFilters}
        //             style={{
        //                 fontFamily: "Maersk Text",
        //                 background: "rgb(66,176,213)",
        //             }}
        //             >
        //             <TuneIcon />
        //             </Button>{" "}
        //         </HoverTip>
        //         </div>
        //         <div>
        //         <HoverTip title="Clear Filter">
        //             <Button
        //             variant="contained"
        //             color="primary"
        //             // onClick={clearfilters}
        //             style={{
        //                 fontFamily: "Maersk Text",
        //                 background: "rgb(66,176,213)",
        //             }}
        //             >
        //             <FilterAltOffIcon />
        //             </Button>{" "}
        //         </HoverTip>
        //         </div>
        //         <div>
        //         <HoverTip title={!isAllStatus? "Closed Cases" : "Open Cases"}>
        //             <Button
        //             variant="contained"
        //             color="primary"
        //             // onClick={toggleStatus}
        //             style={{
        //                 fontFamily: "Maersk Text",
        //                 background: "rgb(66,176,213)",
        //             }}
        //             >
        //             { !isAllStatus ? <ToggleOffIcon/> :< ToggleOnIcon/>}
        //             </Button>
        //         </HoverTip>
        //         </div>
        //     </div>
        //     </div>
        //     <div className="cardsGrid">
        //         <div className="tableCard">
        //             {/* <McCard heading="Table: Region-wise Project Summary" fit="small">
        //                 <CollapsibleOpportunityTable />
        //             </McCard> */}
        //             <McCard heading="Table: Region → Area → Country Project Summary" fit="small">
        //                 <RegionAreaCountryTable data={regionAreaCountryData} />
        //             </McCard>
        //         </div>
        //         <div className="tableCard">
        //             <McCard heading="Table: Project Status VS Country Role" fit="small">
        //                 {renderTable(projStatusVsCountryRoleData, "Project Status")}
        //             </McCard>
        //         </div>
        //     </div>
            
        // </div>
        <div style={{ width: '100%', height: '100%' }}>
        <iframe
          title="Customer Onboarding KPIs"
          width="100%"
          height="800"
          src="https://app.powerbi.com/reportEmbed?reportId=81245b8e-0e61-415e-b307-5ce94f63b515&autoAuth=true&ctid=05d75c05-fa1a-42e7-9cf1-eb416c396f2d"
          //src="https://app.powerbi.com/links/WRnpdLVE7C?ctid=05d75c05-fa1a-42e7-9cf1-eb416c396f2d&pbi_source=linkShare"
          frameBorder="0"
          allowFullScreen={true}
        ></iframe>
      </div>       
    );
};

export default HomeGraphMetrics;


